export default "__VITE_ASSET__CMzlwY88__"